import React, { useEffect, useState } from 'react';
import { useMiddleman } from '@hubins/middleman';
import { LoadingBox } from '@hubins/components/LoadingIndicators';
import Heading from '@hubins/components/Heading';
import ApprovalPortfolioSummaryWithPurpose from '@hubins/components/ApprovalPortfolioSummaryWithPurpose/ApprovalPortfolioSummaryWithPurpose';
// import { ApprovalPortfolioTransactionsList } from '@hubins/components/ApprovalPortfolioTransactions/ApprovalPortfolioTransactions';
import SofItem from './SofItem';
import ScreeningApprovalModal from 'views/Client/Screening/ApprovalModal';
import __ from 'localisation';


const Sof = ({ profile_uuid, /*source_of_funds_uuid,*/ canEdit, endDate, onLoad }) => {
  const middleman = useMiddleman();


  const [loading, setLoading] = useState(true);
  const [sources, setSources] = useState([]);
  const [portfolios, setPortfolios] = useState([]);
  const [profile, setProfile] = useState(null);

  const fetchInitData = async () => {
    setLoading(true);
    try {
      const sofPromise = await middleman.get(`/ql/crm/source-of-funds/filter/${profile_uuid}${endDate ? `/${endDate}` : ''}`);
      const portfoliosPromise = middleman.get(`/ql/crm/profile/portfolios/${profile_uuid}`);
      const profilePromise = middleman.get(`/profile/${profile_uuid}`);
      const [sofResponse, portfoliosResponse, profileResponse] = await Promise.all([sofPromise, portfoliosPromise, profilePromise]);
      setSources(sofResponse.data);
      setPortfolios(portfoliosResponse.data);
      setProfile(profileResponse.data);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchInitData();
  }, []);

  useEffect(() => {
    if (onLoad && !loading) onLoad();
  }, [onLoad, loading]);

  if (loading) return (<LoadingBox />);

  return (
    <>
      <div id="portfolios" data-page-navigation-anchor={__('portfolios')}>
        <Heading size="4" className="s-top-m">
          {__('portfolios')}
        </Heading>
        {portfolios.map((portfolio) => (
          <ApprovalPortfolioSummaryWithPurpose key={portfolio.uuid} portfolioUuid={portfolio.uuid} portfolio={portfolio} endDate={endDate} />
        ))}
      </div>
      {/* <ApprovalPortfolioTransactionsList portfolios={portfolios} status="draft" title={__("pending_transactions")} /> */}
      <div id="sof" data-page-navigation-anchor={__('sof')}>
        <Heading size="4" className="s-top-xl">
          {__('sof')}
        </Heading>

        {sources.map((source) => {
          return (
            <SofItem
              key={source.uuid}
              refetch={fetchInitData}
              canEdit={canEdit}
              {...source}
            />
          );
        })}
      </div>
      <div id="screening" data-page-navigation-anchor={__('screening')}>
        {profile && <ScreeningApprovalModal client={profile} />}
      </div>
    </>
  );
};




export default Sof;
